import Component from '@glimmer/component';
import { t } from 'ember-intl';
import {
  HdsPageHeader,
  HdsAlert,
} from '@hashicorp/design-system-components/components';
import {
  CoreLayoutMain,
  BreadcrumbsContainer,
  FlexGrid,
  Typography,
} from 'core/components';
import UpdatingSecurityGroups from 'hcp/components/page/hvn-peerings/detail/content-tabs/azure/updating-security-groups';

export default class PagePeeringConfigurationInstructionsAzure extends Component {
  <template>
    <CoreLayoutMain>
      <:header>
        <HdsPageHeader as |PH|>
          <PH.Breadcrumb>
            <BreadcrumbsContainer />
          </PH.Breadcrumb>
          <PH.Title>
            {{t
              "components.page.hvn-peerings.detail.configuration-instructions.title"
            }}
          </PH.Title>
        </HdsPageHeader>
      </:header>
      <:body>
        <div class="hvnsPeeringsConfigurationInstructions">
          <div class="hvnsPeeringsConfigurationInstructions__instructions">
            <FlexGrid as |G|>
              <G.Item @xs="12" @sm="12" @md="12" @lg="12">
                <FlexGrid as |G|>
                  <G.Item @xs="12" @sm="12" @md="8" @lg="8">
                    <HdsAlert @type="compact" @color="neutral" as |A|>
                      <A.Description>
                        {{t
                          "components.page.hvn-peerings.detail.instructions.configuration-instructions.banner.info"
                          provider="azure"
                        }}
                      </A.Description>
                    </HdsAlert>
                    <Typography
                      data-test-peerings-configuration-instructions-message
                    >
                      {{t
                        "components.page.hvn-peerings.detail.instructions.configuration-instructions.message"
                        provider="azure"
                      }}
                    </Typography>
                  </G.Item>
                </FlexGrid>
                <UpdatingSecurityGroups
                  data-test-peerings-configuration-instructions-security-groups-content
                  @model={{@model}}
                  @tab={{@tab}}
                  @product={{@product}}
                />
              </G.Item>
            </FlexGrid>
          </div>
        </div>
      </:body>
    </CoreLayoutMain>
  </template>
}
